export function formatCurrency(currency: number, currencySymbol = '€'): string {
  return `${(currency / 100).toLocaleString('de-AT', {
    maximumFractionDigits: 2,
  })} ${currencySymbol}`;
}
